<script setup>
import { useI18n } from 'vue-i18n';
import { useAuth } from '../../composables/useAuth.js';

/* Anzeige für einen Bereich, den die eigene Rolle nicht sehen darf.
 *
 * Bewusst erklärend statt nur sperrend: Wer hier landet, soll wissen, dass der
 * Bereich existiert, warum er verschlossen ist und mit welcher Rolle er
 * zugänglich wäre. Das erspart Nachfragen wie "bei mir fehlt der Reiter". */

defineProps({
  area: { type: String, required: true },
});

const { t } = useI18n();
const { role } = useAuth();
</script>

<template>
  <div class="locked">
    <div class="lock-icon">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
        <rect x="4" y="10.5" width="16" height="10" rx="2" />
        <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" stroke-linecap="round" />
      </svg>
    </div>
    <div class="lock-title">{{ $t('sector.locked') }}</div>
    <p class="lock-text">
      {{ $t('sector.lockedText', { role: t(`roles.${role}`) }) }}
    </p>
    <p class="lock-hint">{{ $t('sector.lockedHint') }}</p>
  </div>
</template>

<style scoped>
.locked {
  padding: 44px 20px;
  text-align: center;
  background: var(--card);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
}
.lock-icon {
  color: var(--dim);
  margin-bottom: 12px;
}
.lock-title {
  font-family: var(--display);
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 6px;
}
.lock-text {
  font-size: 0.8rem;
  color: var(--muted);
  line-height: 1.6;
  max-width: 360px;
  margin: 0 auto;
}
.lock-hint {
  font-size: 0.74rem;
  color: var(--dim);
  line-height: 1.6;
  max-width: 360px;
  margin: 10px auto 0;
}
</style>
